export const NEW_APP = 'NEW_APP';
export const NEW_APP_VERSION = 'NEW_APP_VERION';
export const DARK_MODE = 'DARK_MODE';
export const DARK_MODE_TOGGLE = 'DARK_MODE_TOGGLE';
export const REFRESH_SCREEN = 'REFRESH_SCREEN';
export const FCM_TOKEN = 'FCM_TOKEN';
export const REMOVE_FCM_TOKEN = 'REMOVE_FCM_TOKEN';